import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-news',
  templateUrl: './loading-news.component.html',
  styleUrls: ['./loading-news.component.scss']
})
export class LoadingNewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
